import React, {CSSProperties, PropsWithChildren} from "react"
import {slugifyLowered} from "util/slugifyLowered";

type heading = 1|2|3|4|5|6

type Props = {
    className?: string,
    style?: CSSProperties,
    id?: string,
    headingLevel?: heading
}

export const IdHeading = ({ className, headingLevel = 2, style, children, id }: PropsWithChildren<Props>) => {
    const Tag : React.JSX.Element = 'h' + headingLevel;
    const ref = React.useRef();
    const innerText = (ref.current as any)?.innerText;
    const textContent = (ref.current as any)?.textContent;
    const fallbackInnerText = textContent && typeof textContent === "string" &&
        (textContent.length >= 40 ? slugifyLowered(textContent.slice(0, 39)) : slugifyLowered(textContent));
    const identity = typeof children === "string" && String(children) ||
        innerText || fallbackInnerText;

    if (headingLevel === 0) {
        return (
            <p ref={ref} className={className}>{children}</p>
        )
    }

    return (
        <Tag
            ref={ref}
            id={id || identity && slugifyLowered(`heading-${identity.replaceAll(".", "-")}`) || undefined}
            className={className}
            style={style}>
            {children}
        </Tag>
    )
}
